// #region NRE columns definitions
import { TranslateService } from '@ngx-translate/core';
import { IconType } from '@se/cp.common';
import { GridUtilitiesService } from '../../services/grid-utilities.service';
import { EstensaColDef } from '../search-param.model';

export function nreColumnDefs(translate: TranslateService, gridUtils: GridUtilitiesService): EstensaColDef[] {
    return [
        {
            colId: 'lockColId',
            headerName: '',
            tooltipField: '',
            width: 50,
            suppressSizeToFit: true,
            resizable: false,
            lockPosition: true,
            pinned: 'left',
            cellStyle: { padding: '0' },
            cellRenderer: 'lockUnlockRenderer',
            cellRendererParams: {
                lockedField: 'locked',
                userField: 'lockedUserFullName',
            },
        },
        {
            colId: 'ExamOutOfFlow',
            headerName: '',
            tooltipField: '',
            field: 'patient.isLocalPatient',
            width: 50,
            suppressSizeToFit: true,
            resizable: false,
            lockPosition: true,
            pinned: 'left',
            cellStyle: { padding: '0' },
            cellRenderer: 'boolIconRenderer',
            cellRendererParams: {
                estensa: {
                    iconType: IconType.SeFont,
                    icon: 'icon_flusso_inverso',
                    tooltip: 'PatientDataNotAssociated',
                },
            },
        },
        {
            colId: '0',
            headerName: translate.instant('Patient'),
            headerTooltip: translate.instant('Patient'),
            valueGetter: (e) => {
                const lastName = e.data.patient.lastName ?? '';
                const firstName = e.data.patient.firstName ?? '';
                return `${lastName.toLocaleUpperCase()} ${firstName.toLocaleUpperCase()}`;
            },
            tooltipValueGetter: (e) => {
                const lastName = e.data.patient.lastName ?? '';
                const firstName = e.data.patient.firstName ?? '';
                return `${lastName.toLocaleUpperCase()} ${firstName.toLocaleUpperCase()}`;
            },
            width: 220,
            minWidth: 220,
            suppressSizeToFit: true,
            lockPosition: true,
            pinned: 'left',
            cellStyle: (e) => {
                if (e.data.patient.isCertificating === true) return { 'background-color': 'yellow', color: 'black' };
                if (e.data.patient.isCertificating === false && e.data.patient.isCertified === false)
                    return { 'background-color': 'red' };
                return null;
            },
        },
        {
            headerName: translate.instant('AdmissionDate'),
            headerTooltip: translate.instant('AdmissionDate'),
            field: 'admissionDate',
            colId: '1',
            width: 220,
            minWidth: 220,
            sort: 'desc',
            valueFormatter: gridUtils.dateTimeFormatter('AdmissionDate'),
            comparator: gridUtils.dateComparator,
            suppressSizeToFit: false,
            hide: false,
            tooltipValueGetter: (p) => p.valueFormatted,
        },
        {
            colId: '2',
            headerName: translate.instant('BirthDate'),
            headerTooltip: translate.instant('BirthDate'),
            tooltipValueGetter: (p) => p.valueFormatted,
            field: 'patient.birthDate',
            width: 180,
            minWidth: 180,
            valueFormatter: gridUtils.dateFormatter(['patient', 'birthDate']),
            comparator: gridUtils.dateComparator,
        },
        {
            colId: '3',
            headerName: translate.instant('Sex'),
            headerTooltip: translate.instant('Sex'),
            field: 'patientSex',
            width: 100,
            minWidth: 100,
            suppressSizeToFit: true,
            hide: false,
        },
        {
            colId: '4',
            headerName: translate.instant('Exam'),
            headerTooltip: translate.instant('Exam'),
            field: 'jobDescription',
            width: 200,
            minWidth: 200,
            suppressSizeToFit: true,
        },
        {
            headerName: translate.instant('Status'),
            headerTooltip: translate.instant('Status'),
            tooltipField: 'status',
            field: 'status',
            colId: '5',
            width: 100,
            minWidth: 100,
            suppressSizeToFit: false,
            hide: false,
        },
        {
            headerName: translate.instant('ReferringPhysician'),
            headerTooltip: translate.instant('ReferringPhysician'),
            tooltipField: 'referringPhysicianFullNameList',
            field: 'referringPhysicianFullNameList',
            colId: '6',
            width: 220,
            minWidth: 220,
            suppressSizeToFit: false,
            hide: false,
        },
        {
            headerName: translate.instant('BusinessUnit'),
            headerTooltip: translate.instant('BusinessUnit'),
            tooltipField: 'businessUnit.description',
            field: 'businessUnit.description',
            colId: '7',
            width: 150,
            minWidth: 150,
            suppressSizeToFit: false,
            hide: false,
        },
        {
            headerName: translate.instant('Provenance'),
            headerTooltip: translate.instant('Provenance'),
            tooltipField: 'provenance.description',
            field: 'provenance.description',
            colId: '8',
            width: 150,
            minWidth: 150,
            suppressSizeToFit: false,
            hide: false,
        },
        {
            colId: '9',
            headerName: translate.instant('FolderNumber'),
            headerTooltip: translate.instant('FolderNumber'),
            tooltipField: 'folderNumber',
            field: 'folderNumber',
            width: 190,
            minWidth: 190,
        },
        {
            colId: '10',
            headerName: translate.instant('AdmissionNumber'),
            headerTooltip: translate.instant('EdmissionNumber'),
            tooltipField: 'admissionNumber',
            field: 'admissionNumber',
            width: 190,
            minWidth: 190,
        },
        {
            colId: '11',
            headerName: translate.instant('ExternalAdmissionNumber'),
            headerTooltip: translate.instant('ExternalAdmissionNumber'),
            tooltipField: 'externalNumber',
            field: 'externalNumber',
            width: 190,
            minWidth: 190,
        },
        {
            colId: '12',
            headerName: translate.instant('ExecutorTechnician'),
            headerTooltip: translate.instant('ExecutorTechnician'),
            tooltipField: 'executorTechnician',
            field: 'executorTechnician',
            width: 190,
            minWidth: 190,
            hide: true,
        },
        {
            colId: '13',
            headerName: translate.instant('Room'),
            headerTooltip: translate.instant('Room'),
            tooltipField: 'room.description',
            field: 'room.description',
            width: 190,
            minWidth: 190,
            hide: true,
        },
        {
            colId: '14',
            headerName: translate.instant('Equipment'),
            headerTooltip: translate.instant('Equipment'),
            tooltipField: 'equipment.description',
            field: 'equipment.description',
            width: 190,
            minWidth: 190,
            hide: true,
        },
        {
            colId: '15',
            headerName: translate.instant('RadioIdModality'),
            headerTooltip: translate.instant('RadioIdModality'),
            tooltipField: 'exam.modality.description',
            field: 'exam.modality.description',
            width: 190,
            minWidth: 190,
            hide: true,
        },
    ];
}
